import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Storage from 'vue-ls'

Vue.config.productionTip = false

let vuelsOptions = {
	namespace: 'vuejs_', // key prefix
	name: 'ls', // name variable Vue.[ls] or this.[$ls],
	storage: 'local' // storage name session, local, memory
};
Vue.use(Storage, vuelsOptions);

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')
